import rolesConf from './roles'
import hsvdConfs from './hsvd'
import flyprivateCategoriesConfs from './flyprivate_cats'
import flyprivateVideoPricingConfs from './flyprivate_pricing'
import uploadsConfs from './uploads'
import googleplayinfoConfs from './googleplayinfo'
import itunesinfoConfs from './itunes'
import youtubeinfoConfs from './youtube'
import amazonInfoConfs from './amazon'
import microsoftInfoConfs from './microsoft'
import regionalAttrConfs from './regional'
import youtubeassetinfo from './youtube_asset'
import FilmRatingConfs from './film_rating'
import BundledFilms from './bundledFilms'
import FPPricingsCopy from './FPPricingsCopy'
import FPCatsCopy from './FPCatsCopy'
import seriesEpisodesGen from './seriesEpisodesGen'

export default function _createSubentityConfs(store) {
  return {
    hsvds: hsvdConfs(store),
    flyprivateCategories: flyprivateCategoriesConfs(store),
    roles: rolesConf(store),
    film_rating: FilmRatingConfs(store),
    flyprivate_video_pricing: flyprivateVideoPricingConfs(store),
    uploads: uploadsConfs(store),
    googleplayinfo: googleplayinfoConfs(store),
    amazoninfo: amazonInfoConfs(store),
    microsoftinfo: microsoftInfoConfs(store),
    itunesinfo: itunesinfoConfs(store),
    youtubeinfo: youtubeinfoConfs(store),
    youtube_asset_info: youtubeassetinfo(store),
    videoids: regionalAttrConfs(store),
    bundledFilms: BundledFilms(store),
    FPPricingsCopy: FPPricingsCopy(store),
    FPCatsCopy: FPCatsCopy(store),
    seriesEpisodesGen: seriesEpisodesGen(store)
  }
}
